import { coerceDate } from "../../../lib/time";

/**
 * The full [start, end) window covering EVERY proposed slot, padded a day each
 * side (so an all-day / cross-midnight overlay that merely touches a slot's day
 * still falls in-window). The List View badges use this — NOT the calendar grid's
 * viewport window — so a conflict on a far-month slot still renders regardless of
 * where the grid is navigated (the A-7 windowing fix). Returns null if no slot
 * has a usable start/end.
 *
 * @param {Array<{start: any, end: any}>} slots
 * @param {number} [padMs] padding each side (default one day)
 * @returns {{start: Date, end: Date}|null}
 */
export function slotSpanWindow(slots = [], padMs = 24 * 3600 * 1000) {
  let min = Infinity;
  let max = -Infinity;
  for (const s of slots || []) {
    const st = coerceDate(s?.start)?.getTime();
    const en = coerceDate(s?.end)?.getTime();
    if (st != null) {
      min = Math.min(min, st);
      max = Math.max(max, st);
    }
    if (en != null) {
      min = Math.min(min, en);
      max = Math.max(max, en);
    }
  }
  if (min === Infinity || max === -Infinity) return null;
  return { start: new Date(min - padMs), end: new Date(max + padMs) };
}
